module.exports = __webpack_public_path__ + "static/media/wallet.48502469.svg";